(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-bestseller-slider"] && !Shopify.designMode) return;
  try {
    

  jQuery(document).ready(function () {
  // Swiper: Slider
  new Swiper(".swiper-container", {
    loop: true,
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    slidesPerView: 4,
    paginationClickable: true,
    spaceBetween: 20,
    breakpoints: {
      1920: {
        slidesPerView: 4,
        spaceBetween: 30
      },
      1028: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-goal-based-slider"] && !Shopify.designMode) return;
  try {
    

  jQuery(document).ready(function () {
  // Swiper: Slider
  new Swiper(".swiper-container", {
    loop: true,
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    slidesPerView: 4,
    paginationClickable: true,
    spaceBetween: 20,
    breakpoints: {
      1920: {
        slidesPerView: 4,
        spaceBetween: 30
      },
      1028: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-client-review2"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var totalSlides = $('.js-client-reviews-slider .review-slide').length;
    var dotsToShow = totalSlides <= 4 ? totalSlides : 4;

    $('.js-client-reviews-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      centerPadding:'19%',
      centerMode: false,
      autoplaySpeed: 5000,
      customPaging: function(slider, i) {
        return '<button class="slick-dot">' + (i + 1) + '</button>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var dotContainer = $('.slick-dots');
    if (dotContainer.length) {
      dotContainer.children().slice(4).hide();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-client-review3"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var totalSlides = $('.js-client-reviews-slider .review-slide').length;
    var dotsToShow = totalSlides <= 4 ? totalSlides : 4;

    $('.js-client-reviews-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      centerPadding:'19%',
      centerMode: false,
      autoplaySpeed: 5000,
      customPaging: function(slider, i) {
        return '<button class="slick-dot">' + (i + 1) + '</button>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var dotContainer = $('.slick-dots');
    if (dotContainer.length) {
      dotContainer.children().slice(4).hide();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-detail-review"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var totalSlides = $('.js-client-reviews-slider .review-slide').length;
    var dotsToShow = totalSlides <= 4 ? totalSlides : 4;

    $('.js-client-reviews-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      centerPadding:'19%',
      centerMode: false,
      autoplaySpeed: 5000,
      customPaging: function(slider, i) {
        return '<button class="slick-dot">' + (i + 1) + '</button>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var dotContainer = $('.slick-dots');
    if (dotContainer.length) {
      dotContainer.children().slice(4).hide();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-goals"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
  // Initialize Swiper slider
  new Swiper('.shop-by-goal .swiper-container', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1920: {
        slidesPerView: 4,
        spaceBetween: 25
      },
      1024: { 
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      480: { 
        slidesPerView: 1.5,
        spaceBetween: 10
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-custom"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var totalSlides = $('.js-client-reviews-slider .review-slide').length;
    var dotsToShow = totalSlides <= 4 ? totalSlides : 4;

    $('.js-client-reviews-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      customPaging: function(slider, i) {
        return '<button class="slick-dot">' + (i + 1) + '</button>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var dotContainer = $('.slick-dots');
    if (dotContainer.length) {
      dotContainer.children().slice(4).hide();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
